/**
 * @param {object} props
 * @param {string}  [props.label]
 * @param {string}  [props.error]
 * @param {string}  [props.helperText]
 * @param {import('lucide-react').LucideIcon} [props.leftIcon]  - Lucide icon component
 * @param {import('lucide-react').LucideIcon} [props.rightIcon] - Lucide icon component
 * @param {string}  [props.id]
 * @param {string}  [props.className]
 */
const Input = ({
  label,
  error,
  helperText,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  id,
  className = '',
  ...props
}) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label
          htmlFor={inputId}
          className="text-sm font-medium text-content-secondary"
        >
          {label}
        </label>
      )}

      <div className="relative flex items-center">
        {LeftIcon && (
          <span className="pointer-events-none absolute left-3 text-gray-400">
            <LeftIcon size={16} />
          </span>
        )}

        <input
          id={inputId}
          className={[
            'w-full rounded-md border bg-surface px-3 py-2 text-sm text-content',
            'placeholder:text-content-faint',
            'transition-colors duration-150',
            'hover:border-accent/50 focus:outline-none focus:border-accent/50 focus:ring-2 focus:ring-accent/50',
            'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-content-muted disabled:hover:border-edge-strong',
            error
              ? 'border-red-400 hover:border-red-400 focus:border-red-400 focus:ring-red-400 dark:border-red-500'
              : 'border-edge-strong',
            LeftIcon ? 'pl-9' : '',
            RightIcon ? 'pr-9' : '',
            className,
          ]
            .filter(Boolean)
            .join(' ')}
          {...props}
        />

        {RightIcon && (
          <span className="pointer-events-none absolute right-3 text-gray-400">
            <RightIcon size={16} />
          </span>
        )}
      </div>

      {error && <p className="text-xs text-red-500 dark:text-red-400">{error}</p>}
      {helperText && !error && (
        <p className="text-xs text-content-muted">{helperText}</p>
      )}
    </div>
  );
};

export default Input;
